import { useEffect, useState } from 'react';
import { captureException } from '@sentry/core';

const getTouch = () => {
  try {
    const canTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const canHover = window.matchMedia('(any-hover: hover)').matches;
    return canTouch && !canHover;
  } catch (e) {
    captureException(e);
    return false;
  }
};

export const useTouch = () => {
  const [isTouch, setIsTouch] = useState(getTouch());

  useEffect(() => {
    function handleTouch() {
      setIsTouch(getTouch());
    }

    window.addEventListener('resize', handleTouch);
    return () => window.removeEventListener('resize', handleTouch);
  }, []);

  return isTouch;
};
